import React from 'react';
import SEO from '../components/Seo';
import About from './about';
import { AiOutlineArrowRight } from 'react-icons/ai';
import Fade from 'react-reveal/Fade';
import Bounce from 'react-reveal/Bounce';
import Flip from 'react-reveal/Flip';
import Zoom from 'react-reveal/Zoom';

import { Link } from 'gatsby';

import aboutImage from '../images/about.png';
import { aboutUs } from '../data/aboutUs';
import Contact from './contact';
import FeaturedProjects from '../components/FeaturedProjects';
import FeaturedServices from '../components/FeaturedServices';
import { useVoice } from '../hooks/useVoice';
import { TabSection } from '../components/Tabs';
import HeroSection from '../components/HeroSection';
import { HomeCounters } from '../components/HomeCounters';
import { Helmet } from 'react-helmet';

const IndexPage = () => {
  const Speak = useVoice();

  return (
    <>
      <Helmet>
        <title>Solaric</title>
        <link
          async
          rel='stylesheet'
          type='text/css'
          charset='UTF-8'
          href='https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css'
        />
        <link
          async
          rel='stylesheet'
          type='text/css'
          href='https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css'
        />
      </Helmet>
      <HeroSection />
      <div className='container my-5'>
        <HomeCounters />
        <div className='row'>
          <div className='col-md-6'>
            <img src={aboutImage} className='p-5' alt='' />
          </div>
          <div className='col-md-6'>
            <div
              className='about-content d-flex flex-column justify-content-center mt-2 mt-md-0'
              style={{ height: '100%' }}
            >
              <h5>ABOUT SOLARIC</h5>
              <Fade>
                <h1>Pioneering Rooftop Solar Projects</h1>
              </Fade>
              <p>
                {aboutUs.desc} <Speak text={aboutUs.desc} />
              </p>

              <Link to='/about' className='more-container'>
                Know More
                <AiOutlineArrowRight className='icon' />
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* <About /> */}
      <TabSection />
      <FeaturedServices />
      <FeaturedProjects />
      <Contact />
      <SEO title='Solaric' />
    </>
  );
};

export default IndexPage;
